import { render, staticRenderFns } from "./DotMenu.vue?vue&type=template&id=af673326&scoped=true&"
import script from "./DotMenu.vue?vue&type=script&lang=js&"
export * from "./DotMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af673326",
  null
  
)

export default component.exports